import { forwardRef, type AnchorHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Link — текстовая ссылка (`a` макета): состояния hover/focus/disabled, видимое фокус-кольцо
 * из токенов. Цвет — accent. «disabled» выражается aria-disabled + pointer-events-none (у ссылок
 * нет :disabled), а элемент исключается из обхода фокусом (tabIndex -1). Активация — нативная (Enter).
 */
export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  disabled?: boolean
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, disabled, tabIndex, children, ...props }, ref) => (
    <a
      ref={ref}
      aria-disabled={disabled || undefined}
      tabIndex={disabled ? -1 : tabIndex}
      className={cn(
        'rounded-7 text-accent underline-offset-2 outline-none transition-colors',
        'hover:text-accent-txt hover:underline',
        'focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-panel',
        'aria-disabled:pointer-events-none aria-disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
    </a>
  ),
)
Link.displayName = 'Link'
